import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { knowledgeApi, type Citation } from '../../api/knowledge';

export function CitationExplorerPage() {
  const [citations, setCitations] = useState<Citation[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void knowledgeApi.citations().then(setCitations).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/knowledge" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Knowledge Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Citation Explorer</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-3">
        {citations.map((c) => (
          <li key={c.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{c.title}</span>
              <span className="text-xs text-slate-500">{c.source_type}</span>
            </div>
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{c.excerpt}</p>
            <p className="mt-1 text-xs text-indigo-600">Score: {(c.score * 100).toFixed(0)}%</p>
          </li>
        ))}
        {citations.length === 0 && <li className="text-sm text-slate-500">No citations yet — run a RAG query from Semantic Search</li>}
      </ul>
    </div>
  );
}
